function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var mapObject = (obj, mapFn) => {
  var keys = Object.keys(obj);
  return keys.reduce((newObject, key) => _extends({}, newObject, {
    [key]: mapFn(key, obj[key])
  }), {});
};
export { mapObject };